
<nz-tabset>
  <nz-tab [nzTitle]="personasJuridicasTab">
    <app-organizaciones></app-organizaciones>
  </nz-tab>
</nz-tabset>

<ng-template #personasJuridicasTab>
  <nz-icon nzType="bank" nzTheme="outline" /> Personas Jurídicas
</ng-template>
